import { Component, EventEmitter, Input, OnInit, Output, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastService } from 'angular-toastify';
import { StampAmountMapTableRow, StampDiscountRateOption } from '../../../../../core/models/parking/stamp-discount.model';
import { ApiStampDiscountService } from '../../../../../core/services/api/parking/api-stamp-discount.service';
import { MapperStampDiscountService } from '../../../../../core/mappers/parking/mapper-stamp-discount.service';
import { MapperParkingMasterDataService } from '../../../../../core/mappers/system-settings/mapper-parking-master-data.service';
import { MenuPermissionService } from '../../../../../core/services/menu-permission.service';
import { ModalAdminActivityHistoryComponent } from '../../system-settings/modal-admin-activity-history/modal-admin-activity-history.component';
import { AdminActivityEntityTypes } from '../../../../../core/models/system-settings/admin-activity-log.model';

@Component({
  selector: 'app-modal-stamp-amount-map',
  standalone: true,
  imports: [CommonModule, FormsModule, ModalAdminActivityHistoryComponent],
  templateUrl: './modal-stamp-amount-map.component.html',
  styleUrl: './modal-stamp-amount-map.component.css',
})
export class ModalStampAmountMapComponent implements OnInit {
  @Input() itemId = 0;
  @Input() siteId = 0;
  @Output() close = new EventEmitter<void>();
  @Output() saveSuccess = new EventEmitter<void>();

  readonly activityEntityTypes = AdminActivityEntityTypes;
  showActivityHistory = false;
  formData: StampAmountMapTableRow = {
    id: 0, siteId: 0, siteName: '', amount: 0, parkingRateId: 0, rateId: '', rateName: '',
    name: '', active: true, sequence: null, remark: '', writeDate: null,
  };
  rateOptions: StampDiscountRateOption[] = [];
  isLoading = signal(false);
  isSaving = signal(false);

  private readonly api = inject(ApiStampDiscountService);
  private readonly mapper = inject(MapperStampDiscountService);
  private readonly masterMapper = inject(MapperParkingMasterDataService);
  private readonly toast = inject(ToastService);
  private readonly cookieService = inject(CookieService);
  private readonly router = inject(Router);
  private readonly permissionService = inject(MenuPermissionService);

  get isEdit(): boolean { return this.itemId > 0; }

  ngOnInit(): void {
    this.formData.siteId = this.siteId;
    this.loadRateOptions();
    if (this.isEdit) this.loadDetail();
  }

  onClose(): void { this.close.emit(); }

  onSave(): void {
    if (!this.formData.amount || this.formData.amount <= 0) { this.toast.error('กรุณาระบุ amount'); return; }
    if (!this.formData.parkingRateId) { this.toast.error('กรุณาเลือก rate'); return; }
    const userId = Number(this.cookieService.get('user_id') || 0);
    const menuId = this.permissionService.getMenuId(this.router.url) || 0;
    if (!userId || !menuId) { this.toast.error('ไม่พบข้อมูลสิทธิ์'); return; }

    this.isSaving.set(true);
    this.api.saveStampAmountMap({
      userId, menuId, id: this.formData.id, siteId: this.siteId,
      amount: this.formData.amount, parkingRateId: this.formData.parkingRateId,
      name: this.formData.name, active: this.formData.active,
      sequence: this.formData.sequence, remark: this.formData.remark,
    }).subscribe({
      next: (res) => {
        const mapped = this.masterMapper.mapActionResponse(res);
        this.isSaving.set(false);
        if (mapped.isSuccess) { this.toast.success(mapped.message || 'บันทึกสำเร็จ'); this.saveSuccess.emit(); this.onClose(); }
        else this.toast.error(mapped.message || 'บันทึกไม่สำเร็จ');
      },
      error: (err) => { this.isSaving.set(false); this.toast.error(err?.error?.message || 'เกิดข้อผิดพลาด'); },
    });
  }

  private loadRateOptions(): void {
    this.api.getStampDiscountRateOptions(this.siteId).subscribe({
      next: (res) => { this.rateOptions = this.mapper.mapRateOptions(res); },
      error: () => { this.rateOptions = []; },
    });
  }

  private loadDetail(): void {
    this.isLoading.set(true);
    this.api.getStampAmountMapById(this.itemId).subscribe({
      next: (res) => { this.formData = this.mapper.mapAmountMapRow(res); this.isLoading.set(false); },
      error: () => { this.isLoading.set(false); this.toast.error('โหลดไม่สำเร็จ'); this.onClose(); },
    });
  }

  get canShowActivityHistory(): boolean {
    return this.itemId > 0;
  }

  openActivityHistory(): void {
    if (!this.canShowActivityHistory) return;
    this.showActivityHistory = true;
  }

  closeActivityHistory(): void {
    this.showActivityHistory = false;
  }
}
